import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbWebServices } from "abweb/service/AbWebServices";
import { TimerUtils } from "abweb/utils/TimerUtils";
export class HttpHeartbeat {
  constructor(rpcService = AbWebServices.getRPCService()) {
    _defineProperty(this, "rpcService", void 0);
    _defineProperty(this, "pingSent", void 0);
    _defineProperty(this, "isPinging", void 0);
    _defineProperty(this, "startPinging", () => {
      if (!this.isPinging) {
        this.isPinging = true;
        this.ping();
      }
    });
    _defineProperty(this, "stopPinging", () => {
      this.isPinging = false;
    });
    this.isPinging = false;
    this.pingSent = false;
    this.rpcService = rpcService;
  }
  async ping() {
    if (this.isPinging && !this.pingSent) {
      await this.rpcService.invokeVoid("/api/abweb/polling/ping", null, {}, false);
      this.pingSent = true;
      await TimerUtils.wait(30000);
      this.pingSent = false;
      this.ping();
    }
  }
}
//# sourceMappingURL=HttpHeartbeat.js.map
